class ToggleContainer {
    constructor() {
        this.bindCheckbox();
    }
    bindCheckbox() {
        const checkboxList = Array.from(document.querySelectorAll('.js-toggle-checkbox'));

        checkboxList.map(checkbox => {
            this.toggleWithCheckbox(checkbox);

            checkbox.addEventListener('change', () => this.toggleWithCheckbox(checkbox));
        });
    }
    toggleWithCheckbox(checkbox) {
        const containers = Array.from(document.querySelectorAll(`[data-toggle-container="${checkbox.dataset.toggle}"]`));
        const containersInvert = Array.from(document.querySelectorAll(`[data-toggle-container="${checkbox.dataset.toggleClose}"]`));

        containers.map(container => {
            checkbox.checked ? this.openContainer(container) : this.closeContainer(container);
        });

        containersInvert.map(container => {
            checkbox.checked ? this.closeContainer(container) : this.openContainer(container);
        });
    }
    openContainer(container) {
        container.classList.remove('hidden');
    }
    closeContainer(container) {
        container.classList.add('hidden');
    }
}

new ToggleContainer();
